import type { DashReportDriver } from 'api';
import {
  PROVINCE_ONTARIO,
  PROVINCE_ALBERTA,
  PROVINCE_NEW_BRUNSWICK,
  PROVINCE_NOVA_SCOTIA,
} from 'variables/constants';

export const createEmptyDriver = (): DashReportDriver => ({
  name: '',
  license_number: '',
  status: 'not_ordered',
  consent_given: false,
  consent_id: null,
  dash_log_id: null,
});

export const LICENSE_FORMAT_INFO: Record<
  number,
  { pattern: RegExp; example: string; description: string }
> = {
  [PROVINCE_ONTARIO]: {
    pattern: /^[A-Za-z]\d{4}-?\d{5}-?\d{5}$/,
    example: 'A1234-56789-01234',
    description: 'Letter + 14 digits',
  },
  [PROVINCE_ALBERTA]: {
    pattern: /^\d{9}$/,
    example: '123456789',
    description: '9 digits',
  },
  [PROVINCE_NEW_BRUNSWICK]: {
    pattern: /^\d{6,7}$/,
    example: '123456',
    description: '6-7 digits',
  },
  [PROVINCE_NOVA_SCOTIA]: {
    pattern: /^[A-Za-z]{5}\d{6,9}$/,
    example: 'ABCDE123456',
    description: '5 letters + 6-9 digits',
  },
};

export const validateLicenseFormat = (
  licenseNumber: string,
  province: number,
): { valid: boolean; error?: string } => {
  if (!licenseNumber || !licenseNumber.trim()) {
    return { valid: true };
  }

  const formatInfo = LICENSE_FORMAT_INFO[province];
  if (!formatInfo) {
    return { valid: true };
  }

  const normalized = licenseNumber.trim().toUpperCase();
  if (formatInfo.pattern.test(normalized)) {
    return { valid: true };
  }

  return {
    valid: false,
    error: `Invalid format. Expected: ${formatInfo.description} (e.g., ${formatInfo.example})`,
  };
};
